import Vue from 'vue';
import App from './App.vue';

import _ from 'lodash';
// Vuesax Component Framework
import Vuesax from 'vuesax';
import 'material-icons/iconfont/material-icons.css'; //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax);


import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask);


import VueTheMoney from 'v-money'
Vue.use(VueTheMoney);


import VueNumberInput from '@chenfengyuan/vue-number-input';
Vue.use(VueNumberInput);


// axios
import axios from "./helpers/axios";
Object.defineProperty(Vue.prototype, '$axios', {value: axios});


// Theme Configurations
import '../themeConfig.js';


// Globally Registered Components
import './globalComponents.js';


// Styles: SCSS
import './assets/scss/main.scss';


// Tailwind
import '@/assets/css/main.css';


// Vue Router
import router from './router';


// Vuex Store
import store from './store/store';


// VeeValidate
import pt_BR from 'vee-validate/dist/locale/pt_BR';
import VeeValidate, { Validator } from 'vee-validate';
Vue.use(VeeValidate);
Validator.localize('pt_BR', pt_BR);


// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        // Add your API key here
        key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
        libraries: 'places, geocoding', // This is required if you use the Auto complete plug-in
    },
});


// PrismJS
import 'prismjs';
import 'prismjs/themes/prism.css';


// Feather font icon
require('./assets/css/iconfont.css');


// Tooltip
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';
Vue.use(Tooltip);


import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css'


Vue.config.productionTip = process.env.NODE_ENV === "development";


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
